import AssetManagementRegister from "pages/ManagementAssets/Register"
import Depreciation from "pages/ManagementAssets/Transaction/Depreciation"
import ProfileAsset from "pages/ManagementAssets/Transaction/ProfileAsset"
import { PERMISION } from "security"

// Types
import type { RouteType } from "types"

export const assetManagementRoutes: RouteType[] = [
  {
    path: "/asset-management/register",
    element: <AssetManagementRegister />,
    permission: PERMISION.ASET_MANAGEMENT.REGISTER.PERMISION
  },
  {
    path: "/asset-management/transaction/profile-asset",
    element: <ProfileAsset/>,
    permission: PERMISION.ASET_MANAGEMENT.REGISTER.BY_GROUP.CREATE || PERMISION.ASET_MANAGEMENT.TRANSACTION.PROFILE_ASSET.CREATE
  },
  {
    path: "/asset-management/transaction/profile-asset/:asset_id",
    element: <ProfileAsset/>,
    permission: PERMISION.ASET_MANAGEMENT.REGISTER.BY_GROUP.UPDATE || PERMISION.ASET_MANAGEMENT.TRANSACTION.DEPRECIATION.UPDATE
  },
  {
    path: "/asset-management/transaction/depreciation",
    element: <Depreciation/>,
    permission: PERMISION.ASET_MANAGEMENT.TRANSACTION.DEPRECIATION.CREATE
  },
  {
    path: "/asset-management/journal",
    element: <div/>,
    permission: PERMISION.ASET_MANAGEMENT.JOURNAL.PERMISION
  },
  {
    path: "/asset-management/find",
    element: <div/>,
    permission: PERMISION.ASET_MANAGEMENT.FIND.PERMISION
  }
]